export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-background-100 via-background-50 to-background-50"></div>
      <div className="wrap grid gap-10 py-10 md:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div>
          <p className="kicker mb-5">
            <i className="ri-focus-3-line"></i>
            真伪识别 · 防伪避坑全攻略
          </p>
          <h1 className="font-heading text-3xl leading-tight text-foreground-950 md:text-[2.7rem] md:leading-[1.15]">
            吃瓜官网真假难辨？
            <span className="block text-primary-600">三步看懂官方与仿冒的区别</span>
          </h1>
          <p className="mt-5 max-w-xl text-[15px] leading-7 text-foreground-700">
            面对越来越多的仿冒站点、钓鱼页面与山寨入口，与其凭感觉点击，不如学会系统化的核查方法。本指南带你看懂域名、备案、链接与内容里的关键差异，掌握
            <strong className="font-semibold text-foreground-950">吃瓜官网真假的识别要点</strong>，避开被仿冒网站诱导的陷阱。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#compare"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              看官仿对照表
              <i className="ri-table-line"></i>
            </a>
            <a
              href="#steps"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              学会五步辨真法
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>

          <dl className="mt-8 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {[
              { n: "4", t: "类高危特征" },
              { n: "5", t: "步实操辨真" },
              { n: "12", t: "条对照指标" },
            ].map((it) => (
              <div key={it.t}>
                <dt className="sr-only">{it.t}</dt>
                <dd className="font-heading text-3xl text-secondary-700">{it.n}</dd>
                <dd className="mt-1 text-sm text-foreground-600">{it.t}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative mx-auto max-w-sm lg:max-w-none">
            <div className="absolute -top-4 right-2 z-10 rounded-md bg-accent-500 px-3 py-1.5 text-xs font-bold text-foreground-950 shadow-none">
              <i className="ri-error-warning-line mr-1"></i>本站非官方入口，仅作核查科普
            </div>
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20hand%20holding%20a%20large%20magnifying%20glass%20inspecting%20two%20web%20page%20panels%20marked%20true%20and%20fake%2C%20one%20page%20shows%20an%20official%20seal%20and%20shield%20while%20the%20other%20shows%20a%20cracked%20mask%2C%20warm%20cream%20paper%20background%2C%20vermilion%20red%20amber%20and%20forest%20green%20color%20palette%2C%20minimal%20clean%20modern%20vector%20art%2C%20no%20realistic%20photo&width=760&height=900&seq=hero-main&orientation=portrait"
              alt="放大镜核查真假官网页面的示意插画"
              className="mx-auto w-full max-w-sm rounded-xl border border-background-200 object-cover lg:w-auto"
              width={760}
              height={900}
            />
          </div>
        </div>
      </div>
    </section>
  );
}